<template>
    <button
        v-tippy="t('editorLiftListItem')"
        :class="[
            buttonState(
                editor.can().liftListItem('listItem') &&
                    (editor.isActive('orderedList') || editor.isActive('bulletList')),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().liftListItem('listItem')"
        @click="editor.chain().focus().liftListItem('listItem').run()"
    >
        <MdiFormatIndentDecrease class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatIndentDecrease from 'materialdesignicons-vue3/icons/MdiFormatIndentDecrease.js';

    defineExpose({
        name: 'IndentDecreaseButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
